import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Header from '../_components/Header';
import backIcon from '../_assets/imgs/back.png';
import Spinner from '../_components/Spinner';
import { jobsActions } from '../_actions';

function CompaniesDetail() {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { companyDetail, companyDetailJobs } = useSelector(
    (state) => state.jobsForm
  );

  useEffect(() => {
    dispatch(jobsActions.searchCompaniesByIdAction(id));
    dispatch(jobsActions.searchCompaniesSummaryByIdAction(id));
  }, [dispatch, id]);

  function renderJobs() {
    if (!(companyDetailJobs?.results && companyDetailJobs.results.length)) {
      return (
        <div className="col-md-12 ">
          <Spinner />
        </div>
      );
    }

    return companyDetailJobs.results.map((job) => (
      <div key={job.id} className="col-md-3">
        <Link to={'/vacancies-detail/' + job.id + '?back=companies/' + id}>
          <div className="recommend-box company-detail  clear text-center">
            <div>
              <h3 className="marginless job-name">{job.name}</h3>
              <div className="job-salary">$ {job.salary}</div>
            </div>
          </div>
        </Link>
      </div>
    ));
  }

  function renderCompany() {
    if (companyDetail) {
      return (
        <div className="row">
          <div className="company-name">
            <div className="row">
              <div className="col-md-12 text-center">
                <img
                  src={companyDetail.logo}
                  alt={companyDetail.business_name}
                />
              </div>
            </div>

            <div className="col-md-4">
              <div className="name">
                {companyDetail.business_name} - {companyDetail.rfc}
              </div>
              <div className="activity">
                {companyDetail.user_name} - {companyDetail.activity}
              </div>
            </div>
            <div className="col-md-4">
              <ul className="activity">
                <li>
                  Número de empleados: {companyDetail.employees} empleados
                </li>
                <li>Página web: {companyDetail.site || '-'}</li>
                <li>Teléfono fijo: {companyDetail.phone}</li>
                <li>Teléfono celular: {companyDetail.second_phone || '-'}</li>
              </ul>
            </div>
            <div className="col-md-4">
              <div className="activity">
                {companyDetail.address.street_address_1}{' '}
                {companyDetail.address.neighborhood}{' '}
                {companyDetail.address.city} {companyDetail.address.state} C.P.{' '}
                {companyDetail.address.zip_code}
              </div>
            </div>
          </div>
        </div>
      );
    }
    return '';
  }

  return (
    <div className="dashboard-home">
      <Header />
      <div className="container">
        <Link to="/companies">
          <span className="back">
            <img src={backIcon} alt="" />
            Regresar a compañias
          </span>
        </Link>

        {renderCompany()}

        <div className="jobs-title-container">
          <span className="jobs-subtitle">Vacantes Activas</span>
        </div>

        <div className="row recommend">{renderJobs()}</div>
      </div>
    </div>
  );
}

export { CompaniesDetail };
